// 菜单管理
import http from "@/jslibs/axios/http";

// 新增菜单
export const add = (data) => http.post("/web/permissionManager/addSysPermission", data);

// 编辑菜单
export const edit = (data) => http.post("/web/permissionManager/updateSysPermission", data);

// 菜单详情
export const detail = (data) => http.post("/web/permissionManager/getSysMenuDetail", data);

// 菜单全量列表
export const list = () => http.post("/web/permissionManager/getAllSysPermissionTree");

// 菜单分页列表
export const page = (data) => http.post("/web/permissionManager/getSysMenuList", data);

// 菜单删除
export const del = (data) => http.post("/web/permissionManager/deleteSysPermission", data);
